export default function useLocales() {
  return {
    locale: process.env.GATSBY_LOCALE,
  };
}
